import React from 'react';
import {deleteExperiment} from '../../services/ExperimentService'
import { Link } from "react-router-dom";

class ExperimentRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            name: props.name,
            status: props.status,
            owned: props.owned,
            allowedEdit: props.allowedEdit,
            allowedShare: props.allowedShare,
            jwtToken: props.jwtToken
        };
        this.handleDelete = this.handleDelete.bind(this);
        this.updateTable = this.updateTable.bind(this);
    }

    updateTable(){
        this.props.handler();
    }

    handleDelete(){
        if (window.confirm('Are you sure you want to delete experiment with name:\n"' + this.state.name +'" ?')) {
            deleteExperiment(this.state.jwtToken, this.state.id)
            .then(response =>
                {this.updateTable();}
            );
        }
    }

    render() {
        return (
        <>
            <tr>
                <td>{this.state.name}</td>
                <td>{this.state.status}</td>
                <td>{(this.state.owned) ? "YES" : "NO"}</td>
                <td>
                    <Link to={"/detail/" + this.state.id}>
                        <span title="Show details" className="glyphicon glyphicon-eye-open" />
                    </Link>
                </td>
                <td>
                    {(this.state.status === "EDIT" || this.state.status === "DEBUG") &&
                     (this.state.allowedEdit) ?
                        <Link to={"/edit/" + this.state.id}>
                            <span title="Edit experiment" className="glyphicon glyphicon-edit" />
                        </Link> :
                        <span className="glyphicon glyphicon-edit" />
                    }
                </td>
                <td>
                    {(this.state.allowedShare) ?
                        <Link to={"/share/" + this.state.id}>
                            <span title="Share experiment" className="glyphicon glyphicon-share-alt" />
                        </Link> :
                        <span title="Share experiment" className="glyphicon glyphicon-share-alt" />
                    }
                </td>
                <td>
                    {(this.state.owned) ?
                        <Link to={"#"}>
                            <span title="Delete experiment" onClick={this.handleDelete} className="glyphicon glyphicon-trash" />
                        </Link> :
                        <span title="Delete experiment" className="glyphicon glyphicon-trash" />
                    }
                </td>
            </tr>
        </>
        );
    }
}

export default ExperimentRow;